import * as React from 'react';

interface DualCellProps {
  topText: React.ReactNode;
  bottomText?: React.ReactNode;
  showBottomText?: boolean;
  bottomTextRed?: boolean;
}

export const DualCell: React.FC<DualCellProps> = (props) => {
  const { topText, bottomText, showBottomText, bottomTextRed } = props;

  return (
    <div className="items-center space-x-2 p-2">
      <h5 className="text-sm">{topText || '-'}</h5>
      {showBottomText && (
        <h6
          style={{ margin: 0 }}
          className={`${bottomTextRed ? 'text-red-900' : 'text-gray-600'} text-xs`}
        >
          {bottomText}
        </h6>
      )}
    </div>
  );
};
